module.exports = __webpack_public_path__ + "img/fb.9699b3e2.svg";